export const PRESET_STAGE_OPTIONS = [
  'Screening',
  'Coding Task',
  'Tech I',
  'Tech II',
  'Tech III',
  'Manager',
  'Final',
]

